import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  Stack,
  Grid,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';
import Checkbox from '../checkbox/Checkbox';

import {
  useGetAuthenticationQuery,
  useDeleteAuthKeyMutation,
} from '../../services/ADapi';
import { notificationSuccess } from '../../store/notificationReducer';

const DeleteAuthKeyDialog = ({ isDialogShow, onDialogAction }) => {
  const dispatch = useDispatch();
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const [isChecked, setCheckboxState] = useState(false);

  const [deleteAuthKey, { isLoading }] = useDeleteAuthKeyMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: 'AuthKey was successfully deleted',
  };

  const deleteDomainHandler = async () => {
    try {
      await deleteAuthKey({ user_id }).unwrap();
      onDialogAction();
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      console.error(error);
      onDialogAction();
    }
  };

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  return (
    <Dialog open={isDialogShow} onClose={onDialogAction}>
      <Stack sx={{ gap: '24px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48px',
            height: '48px',
            margin: 'auto',
            borderRadius: '50%',
            backgroundColor: 'warning.main',
          }}
        >
          <GppBadOutlinedIcon
            fontSize="medium"
            sx={{ color: 'primary.contrastText' }}
          />
        </Box>
        <Typography variant="body2">
          Are you sure you want to delete AuthKey?
        </Typography>
        <Checkbox
          label={
            <Typography variant="label" sx={{ pl: 1 }}>
              I understand the old key will be revoked and can’t be recovered
            </Typography>
          }
          checked={isChecked}
          onChange={checkboxStateHandler}
          sx={{
            '.MuiCheckbox-root': {
              p: 0,
            },
            '.MuiTypography-root': {
              textAlign: 'left',
            },
          }}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Button
              variant="error"
              size="small"
              onClick={deleteDomainHandler}
              disabled={!isChecked || isLoading}
              sx={{
                width: '100%',
                backgroundColor: 'error.main',
                color: '#fff',
                '&:disabled': {
                  backgroundColor: 'error.light',
                  color: '#fff',
                },
                '&:hover': {
                  backgroundColor: 'error.main',
                },
              }}
            >
              Delete
              {isLoading ? (
                <CircularProgress size={15} sx={{ ml: 1, color: '#fff' }} />
              ) : null}
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              size="small"
              onClick={onDialogAction}
              sx={{ width: '100%' }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Dialog>
  );
};

export default DeleteAuthKeyDialog;
